
import { NgModule } from '@angular/core';
// import {
//   MatSnackBarModule,
//   MatIconModule,
//   MatSelectModule,
//   MatInputModule,
//   MatFormFieldModule,
//   MatCheckboxModule,
//   MatMenuModule,
//   MatRadioModule
// } from '@angular/material';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatNativeDateModule } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MaterialAutocompleteComponent } from '../material-components/material-autocomplete/material-autocomplete.component';
import { MaterialInputComponent } from '../material-components/material-input/material-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialRadioButtonComponent } from '../material-components/material-radio-button/material-radio-button.component';
import { MaterialCheckboxComponent } from '../material-components/material-checkbox/material-checkbox.component';
import { MaterialTextareaComponent } from '../material-components/material-textarea/material-textarea.component';
import { MaterialDatepickerComponent } from '../material-components/material-datepicker/material-datepicker.component';
import { MaterialButtonComponent } from '../material-components/material-button/material-button.component';
import { MaterialCheckboxListComponent } from '../material-components/material-checkbox-list/material-checkbox-list.component';
import { MaterialMultiselectAutocompleteComponent } from '../material-components/material-multiselect-autocomplete/material-multiselect-autocomplete.component';
// import { MaterialPhoneInputComponent } from '../material-components/material-phone-input/material-phone-input.component';
// import { NgxMatIntlTelInputComponent } from '../components/phone-numner-input/ngx-mat-intl-tel-input.component';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MaterialSelectComponent } from '../material-components/material-select/material-select.component';
import { MaterialTooltipComponent } from '../material-components/material-tooltip/material-tooltip.component';
import { MaterialAutoCompleteChipsComponent } from '../material-components/auto-complete-chips/auto-complete-chips.component';
import { MaterialMenuComponent } from "../material-components/material-menu/material-menu.component";


// import { NgxMatIntlTelInputModule } from "ngx-mat-intl-tel-input";


@NgModule({
  declarations: [
    MaterialAutocompleteComponent,
    MaterialInputComponent,
    MaterialRadioButtonComponent,
    MaterialCheckboxComponent,
    MaterialTextareaComponent,
    MaterialDatepickerComponent,
    MaterialButtonComponent,
    MaterialCheckboxListComponent,
    MaterialMultiselectAutocompleteComponent,
    // MaterialPhoneInputComponent,
    MaterialAutoCompleteChipsComponent,
    MaterialSelectComponent,
    MaterialTooltipComponent,
    MaterialMenuComponent
  ],
  imports: [
    CommonModule,
    MatSnackBarModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatMenuModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatExpansionModule,
    MatNativeDateModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatDividerModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    // NgxMatIntlTelInputComponent,
    MomentDateModule,

  ],
  exports: [
    MatSnackBarModule,
    MatCheckboxModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatMenuModule,
    MatRadioModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatExpansionModule,
    MatNativeDateModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatDividerModule,
    MatMenuModule,
    MaterialAutocompleteComponent,
    MaterialSelectComponent,
    MaterialInputComponent,
    MaterialRadioButtonComponent,
    MaterialCheckboxComponent,
    MaterialTextareaComponent,
    MaterialDatepickerComponent,
    MaterialButtonComponent,
    MaterialCheckboxListComponent,
    MaterialMultiselectAutocompleteComponent,
    // MaterialPhoneInputComponent,
    MaterialAutoCompleteChipsComponent,
    MaterialTooltipComponent,
    MaterialMenuComponent,
    MomentDateModule

    // NgxMatIntlTelInputModule
  ]
})

export class AngularMaterialModule {
}
